var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1129.000000pt",
    height: "1280.000000pt",
    viewBox: "0 0 1129.000000 1280.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)",
    fill: "#9597ae",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7375 12789 c-33 -5 -109 -16 -170 -25 -477 -69 -925 -294 -1269 -638 -373 -374 -594 -854 -637 -1385 -11 -140 -11 -145 8 -160 12 -9 62 -45 112 -80 522 -365 924 -949 1081 -1570 25 -100 37 -166 66 -349 6 -39 36 -56 199 -114 632 -226 1342 -150 1909 204 281 176 542 436 711 709 200 324 311 670 334 1043 62 1017 -563 1939 -1529 2256 -257 85 -641 136 -815 109z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3630 10483 c-261 -19 -572 -107 -811 -228 -685 -345 -1131 -988 -1220 -1755 -15 -137 -7 -472 16 -600 95 -532 361 -1001 755 -1333 410 -345 908 -527 1438 -527 422 0 808 106 1157 317 273 166 530 414 708 683 588 891 455 2084 -315 2826 -460 443 -1083 666 -1728 617z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6566 8083 c-51 -666 -315 -1271 -755 -1727 l-86 -88 120 -42 c935 -330 1668 -1016 2043 -1912 89 -212 170 -485 206 -699 41 -238 47 -337 53 -812 l6 -472 96 5 c799 43 1438 145 2098 335 319 91 691 232 835 315 42 24 84 44 93 44 13 0 15 123 15 1191 0 680 -4 1219 -9 1257 -5 37 -15 117 -21 177 -86 808 -554 1573 -1243 2033 -370 247 -735 385 -1217 459 -90 14 -252 17 -1166 20 l-1062 4 -6 -88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2670 5864 c-967 -73 -1787 -584 -2281 -1419 -181 -307 -318 -721 -358 -1080 -6 -49 -15 -135 -21 -190 -8 -70 -10 -467 -8 -1303 l3 -1204 150 -44 c526 -155 719 -207 1026 -278 741 -171 1450 -274 2164 -315 99 -6 268 -16 375 -22 360 -22 1064 14 1590 80 876 111 1695 340 2207 618 l53 28 0 1260 c0 1345 -1 1371 -51 1620 -116 582 -433 1135 -878 1532 -427 381 -925 610 -1526 700 -97 14 -248 17 -1255 18 -630 1 -1165 0 -1190 -1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollows);
export default __webpack_public_path__ + "static/media/follows.84bfdf7c3bc71c8a2f271e577be35157.svg";
export { ForwardRef as ReactComponent };